export default {
  dbl_personal_data_title: '个人数据',
  dbl_personal_data_enter_analysis: '进入分析',
  dbl_personal_data_search: '搜索表名或表描述',
  dbl_personal_data_table_name: '表名称',
  dbl_personal_data_name: '名称',
  dbl_personal_data_description: '描述',
  dbl_personal_data_creation_time: '创建时间',
  dbl_personal_data_operation: '操作',
  dbl_personal_data_analysis: '分析',
  dbl_personal_data_details: '详情',
  dbl_personal_data_database: '数据库',
  dbl_personal_data_size: '大小',
  dbl_personal_data_table_structure: '表结构',
  dbl_personal_data_data_preview: '数据预览',
  dbl_personal_data_columns: '列',
  dbl_personal_data_column_name: '列名',
  dbl_personal_data_display_name: '显示名称',
  dbl_personal_data_field_name: '字段名称',
  dbl_personal_data_field_type: '字段类型',
  dbl_personal_data_column_type: '数据类型',
  dbl_personal_data_column_comment: '描述',
  dbl_personal_data_metric_dimension: '维度/指标',
  dbl_personal_data_dimension_value_settings: '维度值设置',
  dbl_personal_data_include_dimension_total_value: '是否含维度汇总',
  dbl_personal_data_field_desc: '字段说明',
  dbl_personal_data_metric: '指标',
  dbl_personal_data_dimension: '维度',
  dbl_personal_data_origin: '原维度值',
  dbl_personal_data_system: '系统自动匹配',
  dbl_personal_data_include: '包含',
  dbl_personal_data_exclude: '不包含',
  dbl_personal_data_not_show: '不显示',
  dbl_personal_data_column_nullable: '允许空值',
  dbl_personal_data_column_default: '默认值',
  dbl_personal_data_total: '共 {total} 项',
  dbl_personal_data_select_limit_tip: '最多选择3个，请取消再选择',
  dbl_data_table_size: '表容量',

  // 校验错误提示
  dbl_personal_data_name_empty: '不能为空',
  dbl_personal_data_name_too_long: '长度限制200字符',
  dbl_personal_data_name_invalid_format: '以字母开头，支持字母、数字和下划线，特殊字符必须使用引号或转义符号',
  dbl_personal_data_duplicate_name: '有重名，请重新输入',
  
  dbl_personal_data_upload_data: '上传数据',
  dbl_personal_data_search_sheets: '查找工作簿',
  dbl_personal_data_choose_delimiter: '选择分隔符',
  dbl_personal_data_comma: '","(逗号)',
  dbl_personal_data_semicolon: '";"(分号)',
  dbl_personal_data_colon: '":"(冒号)',
  dbl_personal_data_equal: '"="(等号)',
  dbl_personal_data_space: '空格',
  dbl_personal_data_re_upload: '重新上传',
  dbl_personal_data_enter_table_name: '请输入表名',
  dbl_personal_data_enter_table_description: '请输入表描述',
  dbl_personal_data_table_information: '表格信息',
  dbl_personal_data_support_format: '支持Excel(.xlsx)、CSV和TXT格式文件',
  dbl_personal_data_sheets_selection: '选择工作簿',
  dbl_personal_data_upload_date: '上传日期',
  dbl_personal_data_file_size: '文件大小',
  dbl_personal_data_table_name_empty: '表名不能为空',
  dbl_personal_data_no_item_selected: '未选中任何供预览的项',
  dbl_personal_data_click_to_upload: '点击上传',
  dbl_personal_data_drag_to_area: '拖至此区域',
  dbl_personal_data_next_step: '下一步',
  dbl_personal_data_prev_step: '上一步',
  dbl_personal_data_submit: '提交',
  dbl_personal_data_name_label: '名称',
  dbl_personal_data_description_label: '描述',
  dbl_personal_data_no_sheets_selected: '没有选中的工作表，请返回上一步选择工作表',
  dbl_personal_data_file_exceeds_limit: '文件超过限制',
  dbl_personal_data_file_exceeds_500mb: '文件超过500MB限制',
  dbl_personal_data_file_exceeds_100mb: '文件超过100MB限制',
  dbl_personal_data_cancel_upload: '取消上传',
  dbl_personal_data_delete: '删除',
  dbl_personal_data_delete_title: '确定删除文件？',
  dbl_personal_data_delete_content: '删除操作无法恢复，请谨慎操作',
  dbl_personal_data_release_mouse: '释放鼠标',
  dbl_personal_data_upload: '上传',
  dbl_personal_data_select_sheets: '请在左侧选择工作表',
  dbl_personal_data_close_title: '是否关闭当前上传任务？',
  dbl_personal_data_close_content: '上传任务尚未保存。关闭将导致所有内容丢失。',
  dbl_personal_data_sheet_empty: '该工作簿无数据',
  dbl_personal_data_file_empty: '无法上传空文件。请检查您的文件并重新选择。',
  dbl_personal_data_wrong_file_type: '文件类型错误',
  dbl_personal_data_save_success: '数据上传成功',
  dbl_personal_data_upload_success: '上传成功!',
  dbl_personal_data_upload_fail: '上传失败!',

  // common reuse keys for autotip
  dbl_common_loading: '加载中...',
  dbl_common_load_fail: '加载失败',
  dbl_common_not_search: '未找到匹配结果',
  dbl_common_go_back_old: '返回列表',
};


